import type { RouteRecordRaw } from "vue-router";

export const UsersRoutes: RouteRecordRaw[] = [
    {
        path: '',
        name: 'usersList',
        component: () => import('./components/UsersList.vue')
    },
    {
        path: ':id',
        name: 'usersView',
        component: () => import('./components/UsersView/UsersView.vue')
    },
    {
        path: 'roles',
        name: 'rolesList',
        component: () => import('./components/RolesList.vue')
    },
    {
        path: 'groups',
        name: 'groupsList',
        component: () => import('./components/GroupsList.vue')
    }
]